"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavDrawer = void 0;
var tslib_1 = require("tslib");
var icon_1 = require("../../components/icon");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var page_1 = require("../../page/page");
var services_1 = require("../../services");
var CSS = {
    container: 'c-Nav',
    isVisible: 'c-Nav--isVisible',
    content: 'c-Nav__Content',
    logo: 'c-Nav__Logo',
    username: 'c-Nav__UserName',
    navText: 'c-Nav__NavText',
    logout: 'c-Nav__Logout',
    entry: 'c-Nav__Entry',
    entryCurrent: 'c-Nav__Entry--Current',
    bullet: 'c-Nav__Bullet'
};
var Style = (_a = {},
    _a[CSS.container] = {
        'justify-content': 'space-between',
        'overflow-x': 'hidden'
    },
    _a[CSS.isVisible] = {
        transform: 'translateX(0)'
    },
    _a[CSS.content] = {
        display: 'flex',
        'flex-direction': 'column'
    },
    _a[CSS.logo] = {
        'margin-top': theme_1.DefaultTheme.space(4),
        width: '100%',
        height: '50px'
    },
    _a[CSS.username] = {
        'text-align': 'center',
        margin: "".concat(theme_1.DefaultTheme.space(4), " 0"),
        overflow: 'hidden',
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap'
    },
    _a[CSS.navText] = {
        'text-align': 'left',
        margin: "".concat(theme_1.DefaultTheme.space(1)),
        overflow: 'visible',
        'white-space': 'wrap'
    },
    _a[CSS.logout] = {
        display: 'inline-block',
        padding: "0 0 ".concat(theme_1.DefaultTheme.space(4), " ").concat(theme_1.DefaultTheme.space(4))
    },
    _a[CSS.entry] = {
        height: theme_1.DefaultTheme.space(18),
        display: 'flex',
        'align-items': 'center',
        color: '#757575',
        'font-weight': 700,
        cursor: 'pointer',
        'text-decoration': 'none',
        '&:hover': {
            'background-color': theme_1.DefaultTheme.background.lightGrey,
            color: theme_1.DefaultTheme.color.accent
        }
    },
    _a[CSS.entryCurrent] = {
        cursor: 'default',
        color: theme_1.DefaultTheme.color.accent
    },
    _a[CSS.bullet] = {
        width: theme_1.DefaultTheme.space(18),
        'text-align': 'center'
    },
    _a);
(0, theme_1.addStyles)(Style);
exports.NavDrawer = {
    view: function (ctrl) {
        var entryNodes = [];
        for (var _i = 0, _a = ctrl.entries; _i < _a.length; _i++) {
            var entry = _a[_i];
            entryNodes.push(exports.NavDrawer.viewEntry(ctrl, entry));
        }
        var visibleClass = ctrl.visible ? CSS.isVisible : '';
        return (0, mithril_1.m)('div', {
            className: "".concat(CSS.container, " mdl-layout__drawer ").concat(visibleClass),
            oncreate: function (vnode) { return services_1.Services.FocusAway.from(vnode.dom, function () { return ctrl.setVisible(false); }); }
        }, [
            (0, mithril_1.m)('div', { className: CSS.content }, tslib_1.__spreadArray([
                (0, mithril_1.m)('img', { className: CSS.logo, src: (0, theme_1.assetPath)('/images/ike_logo.svg') }),
                (0, mithril_1.m)('span', { className: CSS.username }, ctrl.username)
            ], entryNodes, true)),
            (0, mithril_1.m)('div', { className: CSS.content }, [
                (0, mithril_1.m)('a', { className: CSS.logout, href: services_1.Services.Route.getRouteURL(page_1.IkePageName.logout) }, (0, i18n_1.Translate)(i18n_1.T.LOGOUT))
            ])
        ]);
    },
    viewEntry: function (ctrl, entry) {
        var _this = this;
        if (entry.current) {
            return (0, mithril_1.m)('a', {
                className: "".concat(CSS.entry, " ").concat(CSS.entryCurrent)
            }, [
                icon_1.Icon.view(entry.icon, { className: CSS.bullet }),
                (0, mithril_1.m)('span', { className: CSS.navText }, (0, i18n_1.Translate)(entry.title))
            ]);
        }
        return (0, mithril_1.m)('a', {
            className: CSS.entry,
            href: services_1.Services.Route.getRouteURL(entry.name),
            target: entry.type === 'external' ? '_blank' : undefined,
            onclick: entry.type === 'internal'
                ? function (e) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, services_1.Services.Window.confirmPageChange(e, services_1.Services.Route.getRouteURL(entry.name))];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }
                : undefined
        }, [
            icon_1.Icon.view(entry.icon, { className: CSS.bullet }),
            (0, mithril_1.m)('span', { className: CSS.navText }, (0, i18n_1.Translate)(entry.title))
        ]);
    }
};
//# sourceMappingURL=nav.drawer.js.map